import React from 'react';

export default function RocketLoader({ size = 200, style = {}, message = '' }) {
  const spinnerSize = Math.round(size * 0.22);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 16, ...style }}>
      <style>{`
        @keyframes rl-spin { to { transform: rotate(360deg); } }
        @keyframes rl-pulse { 0%,100% { opacity:1; } 50% { opacity:0.4; } }
      `}</style>
      <div style={{
        width: spinnerSize,
        height: spinnerSize,
        borderRadius: '50%',
        border: String(Math.max(2, Math.round(spinnerSize * 0.09))) + 'px solid #F3F4F6',
        borderTopColor: '#EF1D28',
        animation: 'rl-spin 0.7s linear infinite',
        flexShrink: 0,
      }} />
      {message && (
        <p style={{
          margin: 0,
          fontSize: 14,
          color: '#6B7280',
          fontWeight: 500,
          fontFamily: 'Inter, sans-serif',
          animation: 'rl-pulse 1.8s ease-in-out infinite',
          textAlign: 'center',
          maxWidth: 240,
          lineHeight: 1.5,
        }}>
          {message}
        </p>
      )}
    </div>
  );
}

export function FullPageRocketLoader({ message = 'Loading…' }) {
  return (
    <div style={{
      position: 'fixed', inset: 0, display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: 'white', zIndex: 9999,
    }}>
      <RocketLoader size={200} message={message} />
    </div>
  );
}
